import React from "react";
import "./BedroomGallery.css";

const BedroomGallery = () => {
  // Group images by bedroom
  const bedroomGroups = [
    {
      title: "Bedrooms One and Two in Main House",
      images: [
        `${process.env.PUBLIC_URL}/BR-1Resized.jpg`,
        `${process.env.PUBLIC_URL}/BR-2Resized.jpg`,
      ],
    },
    {
      title: "Cottage",
      images: [
        `${process.env.PUBLIC_URL}/Cottage-InteriorResized.jpg`,
        `${process.env.PUBLIC_URL}/Cottage-ExteriorResized.jpg`,
      ],
    },
  ];

  return (
    <div className="bedroom-gallery">
      <h2>Our Bedrooms</h2>
      {bedroomGroups.map((group, groupIndex) => (
        <div key={groupIndex} className="bedroom-group">
          <h3 className="bedroom-title">{group.title}</h3>
          <div className="bedroom-grid">
            {group.images.map((image, index) => (
              <div key={index} className="bedroom-item">
                <img
                  src={image}
                  alt={`${group.title} - View ${index + 1}`}
                  className="bedroom-image"
                  loading="lazy"
                  onError={(e) => {
                    console.error(`Failed to load image: ${image}`);
                    e.target.style.display = "none";
                  }}
                />
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default BedroomGallery;
